import React from 'react';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation()
  return (
    <footer id="footer">
      <br />
      <div className="container service_info">
        <div id="serviceCaution">
          <span>
            <a href="https://www.kigam.re.kr/menu.es?mid=a10906020000" target="_blank"  rel="noreferrer">{t('footer.privacyPolicy')}</a>
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
            <a href="https://data.kigam.re.kr/about/email" target="_blank"  rel="noreferrer">{t('footer.rejectionOfEmailCollection')}</a>
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
            <a href="https://data.kigam.re.kr/quake/intro/terms" target="_blank"  rel="noreferrer">{t('footer.termsOfUse')}</a>
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
            <a href="mailto:kquake@kigam.re.kr">{t('footer.contactUs')}</a>
          </span>
        </div>
      </div>
      <br/>
      <div className="divider"></div>
      <div className="container">
        <br/>
        <div id="serviceContact">
          <span>
            {t('footer.address')}
            {/*&nbsp;&nbsp;&nbsp;<a href="tel:042-868-3345">TEL.042-868-3345</a>*/}
            &nbsp;&nbsp;&nbsp; Email: <a href="mailto: kquake@kigam.re.kr">kquake@kigam.re.kr</a>
          </span>
        </div>
        <div id="serviceCopyright">
          <span>Copyright 2021 KIGAM. All Right Reserved.</span>
        </div>
      </div>
      <br />
    </footer>
  );
}